import Icon, { IconProps } from './Icon';

import LinkIcon from '../../../assets/icons/link-01.svg?react';

const Link: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <LinkIcon />
    </Icon>
  );
};

export default Link;
